// Unified tactile feedback — fire haptic + UI sound together so every
// interactive surface in the app feels physical. Use these instead of
// calling haptics + sounds individually.
import { hapticLight, hapticMedium, hapticSuccess, hapticError } from './haptics.js'
import { soundTap, soundTapBack, soundToggle, soundPositive, soundNeutral } from './sounds.js'

// Standard button press — covers card taps, chip taps, nav tabs, list rows.
export function tap() {
  hapticLight()
  soundTap()
}

// Back / dismiss — back chevrons, modal close, nav-up.
export function tapBack() {
  hapticLight()
  soundTapBack()
}

// Toggle switch flip. Pass the new state so the sound's second tone
// matches the direction (rises when turning on, falls when turning off).
export function tapToggle(nextOn = true) {
  hapticMedium()
  soundToggle(nextOn)
}

// Confirmation / success — used for irreversible-but-good actions like
// sending an answer, claiming a reward, completing onboarding.
export function tapSuccess() {
  hapticSuccess()
  soundPositive()
}

// Soft "no" — used for disabled taps, gentle errors, "not yet" feedback.
export function tapDeny() {
  hapticError()
  soundNeutral()
}
